import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import WebView from '@medscape-promo/medscapetv/web-view';
import WebViewReducers from '@medscape-promo/medscapetv/web-view/web-view.reducers';
import WebViewMiddleware from '@medscape-promo/medscapetv/web-view/web-view.middleware';
import ShowMoreReducers from './template/show-more/show-more.reducers';
import AboutSeriesTemplate from './template';

export default class AboutSeries extends Component {
    constructor(props) {
        super(props);
        const middlewares = [
            WebViewMiddleware
        ];
        const middlewareEnhancers = applyMiddleware.apply(null, middlewares);
        const reducers = combineReducers({
            ShowMore: ShowMoreReducers,
            WebView: WebViewReducers
        });


        this.store = createStore(reducers, middlewareEnhancers);
        require('./about-series.scss');
        //console.log("[AboutSeries] props:", props);
    }
    componentDidMount() {
        this.props.onReady(this.store);
    }
    render() {
        const { props } = this;
        if(props.config.enable === false) {
            return null;
        }
        return (
            <Provider store={this.store}>
                <WebView medscape={props.medscape}>
                    <AboutSeriesTemplate {...props.config} />
                </WebView>
            </Provider>
        )
    }
    static get propTypes() {
        return {
            medscape: PropTypes.object.isRequired,
            "config": PropTypes.object.isRequired,
            onReady: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onReady: () => {}
        }
    }
}